export enum MasterAppointmentsTypes {
    APPOINTMENT_TYPES = "appointmentType",
    APPOINTMENT_TYPE_ACTUATION = "appointmentTypeActuation",
    RESTRICTION_DATE = "restrictionDate",
    BOARD = "board",
    APPOINTMENT_PERMISSION="appointmentPermission"
}
